import { render } from "./CompanyForm.vue?vue&type=template&id=454f58cc&scoped=true"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"

import "./CompanyForm.vue?vue&type=style&index=0&id=454f58cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454f58cc"]])

export default __exports__